import Swiper from "swiper/bundle";

export const initSwiper = () => {
    new Swiper(".home-swiper", {
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        slidesPerView: 1,
        pagination: {
            el: ".home-swiper .swiper-pagination",
            clickable: true
        },
    });
}